const targetSectionRefs1 = document.querySelectorAll('section.detail-cards-new--js');

if (targetSectionRefs1.length) {
  targetSectionRefs1.forEach(targetSectionElement => {
    let clickCount = 1;

    const fraction = document.createElement('div');
    fraction.classList.add('fraction');
    
    const customHolder = targetSectionElement.querySelector('.swiper-pagination--custom-holder');
    if (customHolder) {
      customHolder.appendChild(fraction);
    }

    const swiperElement = targetSectionElement.querySelector('.swiper');
    
    if (swiperElement) {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        watchOverflow: true,
        breakpoints: {
          1641: {
            spaceBetween: 30
          }
        }
      });

      swiper.on('slideChange', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });
      swiper.on('init', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });

      swiper.init();
      updateFraction(swiper, fraction);
      updateLockClass(swiper, targetSectionElement);

      function updateFraction(swiper, fraction) {
        const activeSlides = Array.from(swiper.slides);
        const activeSlideCount = activeSlides.length;
        let actualSlidesPerView = getActualSlidesPerView(swiper);

        const result = Math.round(activeSlideCount - actualSlidesPerView);
        const currentIndex = swiper.realIndex + 1;
      
        if (currentIndex > result) {
          fraction.textContent = `${result} / ${result}`;
        } else {
          fraction.textContent = `${currentIndex} / ${result}`;
        }
      }

      function getActualSlidesPerView(swiper) {
        const swiperWidth = swiper.width;
        const slides = swiper.slides;
        let totalSlidesWidth = 0;
        let slidesPerView = 0;
      
        for (let i = 0; i < slides.length; i++) {
          totalSlidesWidth += slides[i].offsetWidth + parseFloat(getComputedStyle(slides[i]).marginRight);
      
          if (totalSlidesWidth > swiperWidth) {
            break;
          }
          
          slidesPerView++;
        }
        return slidesPerView;
      }

      function updateLockClass(swiper, targetSectionElement) {
        const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
        const nextButton = targetSectionElement.querySelector('.swiper-button-next');
        const swiperElement = targetSectionElement.querySelector('.swiper');
  
        if (prevButton.classList.contains('swiper-button-lock') || nextButton.classList.contains('swiper-button-lock')) {
          swiperElement.classList.add('swiper--lock');
        } else {
          swiperElement.classList.remove('swiper--lock');
        }
      }

      const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
      const nextButton = targetSectionElement.querySelector('.swiper-button-next');

      prevButton.addEventListener('click', () => {
        // swiper.slidePrev();
        clickCount--;
        updateFraction(swiper, fraction);
      });

      nextButton.addEventListener('click', () => {
        // swiper.slideNext();
        clickCount++;
        updateFraction(swiper, fraction);
      });
    }
  });
}

const targetSectionSlider = document.querySelectorAll('section.slider-images');

if (targetSectionSlider.length) {
  targetSectionSlider.forEach(targetSectionElement => {
    let clickCount = 1;

    const fraction = document.createElement('div');
    fraction.classList.add('fraction');
    
    const customHolder = targetSectionElement.querySelector('.swiper-pagination--custom-holder');
    if (customHolder) {
      customHolder.appendChild(fraction);
    }

    const swiperElement = targetSectionElement.querySelector('.swiper');
    
    if (swiperElement) {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,
        slidesPerGroup: 1,
        slidesToScroll: 1,
        navigation: {
          prevEl: ".slider-images .swiper-button-prev",
          nextEl: ".slider-images .swiper-button-next",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        watchOverflow: true,
        breakpoints: {
          1700: {
            slidesPerView: 4.6
          },
          1200: {
            slidesPerView: 3.6
          },
          750: {
            slidesPerView: 2
          }
        },
      });

      function copySlides() {
        const slides = swiperElement.querySelectorAll('.slide-without-popup');

        swiper.params.centeredSlides = true;
        swiper.update();
        swiper.slideTo(2);

        slides.forEach(slide => {
          swiper.appendSlide(slide.cloneNode(true));
        });
        
      }
      copySlides();

      swiper.on('slideChange', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });
      swiper.on('init', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });

      swiper.init();
      updateFraction(swiper, fraction);
      updateLockClass(swiper, targetSectionElement);

      function updateFraction(swiper, fraction) {
        const activeSlides = Array.from(swiper.slides);
        const activeSlideCount = activeSlides.length;
        let actualSlidesPerView = getActualSlidesPerView(swiper);

        const result = Math.round(activeSlideCount - actualSlidesPerView);
        const currentIndex = swiper.realIndex + 1;
      
        if (currentIndex > result) {
          fraction.textContent = `${result} / ${result}`;
        } else {
          fraction.textContent = `${currentIndex} / ${result}`;
        }
      }

      function getActualSlidesPerView(swiper) {
        const swiperWidth = swiper.width;
        const slides = swiper.slides;
        let totalSlidesWidth = 0;
        let slidesPerView = 0;
      
        for (let i = 0; i < slides.length; i++) {
          totalSlidesWidth += slides[i].offsetWidth + parseFloat(getComputedStyle(slides[i]).marginRight);
      
          if (totalSlidesWidth > swiperWidth) {
            break;
          }
          
          slidesPerView++;
        }
        return slidesPerView;
      }

      function updateLockClass(swiper, targetSectionElement) {
        const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
        const nextButton = targetSectionElement.querySelector('.swiper-button-next');
        const swiperElement = targetSectionElement.querySelector('.swiper');
  
        if (prevButton.classList.contains('swiper-button-lock') || nextButton.classList.contains('swiper-button-lock')) {
          swiperElement.classList.add('swiper--lock');
        } else {
          swiperElement.classList.remove('swiper--lock');
        }
      }

      const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
      const nextButton = targetSectionElement.querySelector('.swiper-button-next');

      prevButton.addEventListener('click', () => {
        swiper.slidePrev();
        clickCount--;
        updateFraction(swiper, fraction);
      });

      nextButton.addEventListener('click', () => {
        swiper.slideNext();
        clickCount++;
        updateFraction(swiper, fraction);
      });
    }
  });
}

const targetSectionSliderVSQ = document.querySelectorAll('section.vsq-set--cardsSection');

if (targetSectionSliderVSQ.length) {
  targetSectionSliderVSQ.forEach(targetSectionElement => {
    let clickCount = 1;

    const fraction = document.createElement('div');
    fraction.classList.add('fraction');
    
    const customHolder = targetSectionElement.querySelector('.swiper-pagination--custom-holder');
    if (customHolder) {
      customHolder.appendChild(fraction);
    }

    const swiperElement = targetSectionElement.querySelector('.swiper');
    
    if (swiperElement) {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 20,
        slidesToScroll: 1,
        navigation: {
          prevEl: ".slider-images .swiper-button-prev",
          nextEl: ".slider-images .swiper-button-next",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        watchOverflow: true,
        breakpoints: {
          1200: {
            slidesPerView: 4
          },
          992: {
            slidesPerView: 3
          },
          750: {
            slidesPerView: 2
          }
        },
      });

      swiper.on('slideChange', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });
      swiper.on('init', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });

      swiper.init();
      updateFraction(swiper, fraction);
      updateLockClass(swiper, targetSectionElement);

      function updateFraction(swiper, fraction) {
        const activeSlides = Array.from(swiper.slides);
        const activeSlideCount = activeSlides.length;
        let actualSlidesPerView = getActualSlidesPerView(swiper);

        const result = Math.round(activeSlideCount - actualSlidesPerView);
        const currentIndex = swiper.realIndex + 1;
      
        if (currentIndex > result) {
          fraction.textContent = `${result} / ${result}`;
        } else {
          fraction.textContent = `${currentIndex} / ${result}`;
        }
      }

      function getActualSlidesPerView(swiper) {
        const swiperWidth = swiper.width;
        const slides = swiper.slides;
        let totalSlidesWidth = 0;
        let slidesPerView = 0;
      
        for (let i = 0; i < slides.length; i++) {
          totalSlidesWidth += slides[i].offsetWidth + parseFloat(getComputedStyle(slides[i]).marginRight);
      
          if (totalSlidesWidth > swiperWidth) {
            break;
          }
          
          slidesPerView++;
        }
        return slidesPerView;
      }

      function updateLockClass(swiper, targetSectionElement) {
        const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
        const nextButton = targetSectionElement.querySelector('.swiper-button-next');
        const swiperElement = targetSectionElement.querySelector('.swiper');
  
        if (prevButton.classList.contains('swiper-button-lock') || nextButton.classList.contains('swiper-button-lock')) {
          swiperElement.classList.add('swiper--lock');
        } else {
          swiperElement.classList.remove('swiper--lock');
        }
      }

      const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
      const nextButton = targetSectionElement.querySelector('.swiper-button-next');

      prevButton.addEventListener('click', () => {
        swiper.slidePrev();
        clickCount--;
        updateFraction(swiper, fraction);
      });

      nextButton.addEventListener('click', () => {
        swiper.slideNext();
        clickCount++;
        updateFraction(swiper, fraction);
      });
    }
  });
}

const openModalContainer = document.querySelectorAll('.slide-with-popup');
const closeModalButtons1 = document.querySelectorAll('.modal-btn-close');
const modals1 = document.querySelectorAll('.card-modal-content');
const detailCardSection = document.querySelector('.detail-cards--section'); // add modal at the end of section to save styles
const videoBlock = document.querySelectorAll('.modal-video--box'); // for autoplay video inside the cards
const svxCardSection = document.querySelector('.detail-cards--section.svx-landing');
const svxAnchorButtons = svxCardSection?.querySelectorAll('.svx-landing-btn');
const body = document.body;

const modalCache = {};

modals1.forEach(modal => {
  modalCache[modal.id] = modal;
  modal.remove();
});

let currentModal1 = null;

function openModal(modal) {
  detailCardSection.appendChild(modal); // rendering a popup only if user clicked on card
  modal.classList.add('active');
  body.classList.add('no-scroll');
  currentModal1 = modal;
  // for autoplay video inside the cards
  videoBlock.forEach(element => {
    const video = element.querySelector('video');
    video.play();
  });
}

function closeModal(modal) {
  modal.classList.remove('active');
  body.classList.remove('no-scroll');
  modal.remove();
  currentModal1 = null;
}

openModalContainer.forEach(button => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    const modalId = button.getAttribute('data-target').replace('#', '');
    const targetModal = modalCache[modalId];
    if (targetModal) {
      openModal(targetModal);
    }
  });
});

closeModalButtons1.forEach(button => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    if (currentModal1) {
      closeModal(currentModal1);
    }
  });
});
modals1.forEach(modal => {
  let wideCard = modal.querySelector('.wide-card-container');
  let wideCardSecond = modal.querySelector('.wide-row--block');

  if (wideCard || wideCardSecond) {
    modal.classList.add('wide__card')
  }

  modal.addEventListener('click', (event) => {
    event.stopPropagation();
    if (currentModal1) {
      closeModal(currentModal1);
    }
  });
});

document.addEventListener('click', (event) => {
  if (currentModal1 && !currentModal1.contains(event.target)) {
    closeModal(currentModal1);
  }
});

document.querySelectorAll('.wide-card-container').forEach((element) => {
  const closestHolder = element.closest('.card-modal--holder');
  if (closestHolder) {
      closestHolder.classList.add('full-width');
  }
});

svxAnchorButtons?.forEach(button => {
  button.addEventListener('click', () => {
    document.querySelector('.section-collections-card-slider.svx-landing')
      .scrollIntoView({ behavior: "smooth", block: "end"});
  });
});